import { render, staticRenderFns } from "./ListarPlanos.vue?vue&type=template&id=0f9fb86a&scoped=true&"
import script from "./ListarPlanos.vue?vue&type=script&lang=js&"
export * from "./ListarPlanos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fb86a",
  null
  
)

export default component.exports